import HeadSeo from "components/HeadSeo/HeadSeo";
import Estimation from "containers/v2/Estimation";
import siteMetadata from "data/siteMetadata";
import useTranslation from "next-translate/useTranslation";
import Head from "next/head";
import nookies from "nookies";
import { useEffect, useLayoutEffect, useRef } from "react";

import { useSelector } from "react-redux";
import {
  setAuthenticated,
  setEmail,
  setUID,
  setUser,
  signInR,
  updateUser,
} from "redux/slices/authReducer";
import {
  actions as EstimationActions,
  selectors as EstimationSelectors,
} from "redux/slices/v2/EstimationReducer";
import api_call_v2 from "utils/API_CALL/api_call_v2";
import match from "utils/Estimation/match_api_form";
import formatUrl from "utils/FormatUrl";

const buildUrl = (
  activeStep,
  selectedType,
  estimationId,
  shareId,
  userResult,
  lang = "fr"
) => {
  if (userResult) {
    return formatUrl(
      `user/${selectedType.toLowerCase()}/estimation?token=${estimationId}`,
      lang
    );
  }
  if (activeStep == 11) {
    return formatUrl(`estimation/update?updateid=${estimationId}`, lang);
  } else {
    return formatUrl(
      `/estimation/${
        activeStep == 1 || activeStep == 0
          ? "map"
          : activeStep == 2
          ? "bien"
          : activeStep >= 3
          ? selectedType == "Appartement"
            ? "appartement"
            : selectedType == "Villa"
            ? "villa"
            : "maison"
          : ""
      }${
        activeStep == 4
          ? "/caracteristiques"
          : activeStep == 5
          ? "/complement"
          : activeStep == 6
          ? "/form"
          : activeStep == 7
          ? "/form"
          : activeStep == 8
          ? "/signin"
          : activeStep == 9
          ? "/signup"
          : activeStep == 10
          ? "/resultat"
          : ""
      }${estimationId ? `?token=${estimationId}` : ""}${
        !estimationId && shareId ? `?shareId=${shareId}` : ""
      }`,
      lang
    );
  }
};

export default function EstimationPagesHepler(props) {
  const activeStep = useSelector(EstimationSelectors.activeStepSelector);
  const selectedType = useSelector(EstimationSelectors.selectedTypeSelector);
  const estimationId: any = useSelector<any>(
    EstimationSelectors.estimationIdSelector
  );
  const shareId: any = useSelector<any>(EstimationSelectors.shareIdSelector);
  const { lang } = useTranslation("");
  useEffect(() => {
    // const analytics = getAnalytics(app);
    let url = buildUrl(
      activeStep,
      selectedType,
      estimationId,
      shareId,
      props.userResult,
      lang
    );
    // if (process.env.NEXT_PUBLIC_DATADOG_ENABLED) {
  }, []);
  const firstUpdateSP = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdateSP.current) {
      firstUpdateSP.current = false;
      return;
    } else {
      // const analytics = getAnalytics(app);
      let url = buildUrl(
        activeStep,
        selectedType,
        estimationId,
        shareId,
        props.userResult,
        lang
      );

      // if (process.env.NEXT_PUBLIC_DATADOG_ENABLED) {

      window.history.pushState(
        {},
        "",
        formatUrl(url, lang).replace("https://agenz.ma", "")
      );
    }
  }, [activeStep]);
  return (
    <>
      <Head>
        <link
          href="https://api.mapbox.com/mapbox-gl-js/v2.7.0/mapbox-gl.css"
          rel="stylesheet"
        />
        <link
          href="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v4.2.0/mapbox-gl-geocoder.css"
          rel="stylesheet"
        />
      </Head>
      <HeadSeo
        title={
          activeStep == 11
            ? "Mettez à jour votre estimation"
            : "Estimation immobilière en ligne - Maroc"
        }
        description={`L’outil d’estimation en ligne développé par agenz permet d’estimer le prix de vente ou d’estimer le loyer de votre appartement ou maison`}
        ogImageUrl={siteMetadata.siteLogoSquare}
        ogTwitterImage={siteMetadata.siteLogoSquare}
        ogType={"website"}
        ogTitle={
          activeStep == 11
            ? "Mettez à jour votre estimation"
            : "Estimation immobilière en ligne - Maroc"
        }
        ogDescription={`L’outil d’estimation en ligne développé par agenz permet d’estimer le prix de vente ou d’estimer le loyer de votre appartement ou maison`}
        canonicalUrl={`https://agenz.ma/estimation/map`}
        structuredData={null}
      >
        {/* <></> */}
      </HeadSeo>
      <Estimation />
    </>
  );
}

export const getServerSideHelper = async (
  store: any,
  ctx: any,
  activeStep: any
) => {
  try {
  } catch (e) {}
  const params = new Proxy(new URLSearchParams(ctx.req.url.split("?")[1]), {
    get: (searchParams: any, prop: any) => searchParams.get(prop),
  });

  const cookies = nookies.get(ctx);
  const cookies_un = nookies.get(undefined);
  const accessToken =
    ctx.req.cookies.AccessToken ||
    cookies.AccessToken ||
    cookies_un.AccessToken;
  let user = null;

  return new Promise(async (resolve, reject) => {
    store.dispatch(
      EstimationActions.setGeocoding({
        version: ctx.query.version ? ctx.query.version : "estimation",
        // version: "estimation",
        lat:
          ctx.query.lat && ctx.query.lng
            ? Math.max(ctx.query.lat, ctx.query.lng)
            : null,
        lng:
          ctx.query.lat && ctx.query.lng
            ? Math.min(ctx.query.lat, ctx.query.lng)
            : null,
        adresse: ctx.query.adresse,
        province: ctx.query.province ? ctx.query.province : "",
        zoom: ctx.query.zoom,
        marker: ctx.query.zoom ? (ctx.query.zoom > 12 ? true : false) : false,
      })
    );
    try {
      if (accessToken) {
        api_call_v2(ctx, "get", "getUser", {}, "cloud_functions", true)
          .then((res) => {
            user = res.data;

            if (activeStep < 10) {
              if (ctx.query.token || params.token) {
                store.dispatch(
                  EstimationActions.setEstimationId(
                    ctx.query.token || params.token
                  )
                );
                store.dispatch(
                  EstimationActions.setResultViewType("ESTIMATION")
                );
              } else if (ctx.query.shareId || params.shareId) {
                store.dispatch(
                  EstimationActions.setShareId(
                    ctx.query.shareId || params.shareId
                  )
                );
                store.dispatch(EstimationActions.setResultViewType("SHARED"));
              } else if (ctx.query.updateid || params.updateid) {
                store.dispatch(
                  EstimationActions.setEstimationId(
                    ctx.query.updateid || params.updateid
                  )
                );
                store.dispatch(
                  EstimationActions.setResultViewType("ESTIMATION")
                );
              }
              if (activeStep == 1 || activeStep == 0) {
                store.dispatch(EstimationActions.setActiveStep(activeStep));
                resolve({});
              } else {
                resolve({
                  redirect: {
                    destination: `/estimation/map`,
                    permanent: false,
                  },
                });
              }
            } else {
              if (ctx.query.token || params.token) {
                api_call_v2(
                  ctx,
                  "post",
                  "estimation/user/estimation",
                  {
                    estimationId: ctx.query.token || params.token,
                    force_send_email: true,
                  },
                  "cloud_functions",
                  true
                )
                  .then(async (estimation) => {
                    let estimation_data = match(estimation.data);
                    if (estimation_data.graphe) {
                      store.dispatch(
                        EstimationActions.setGraphes(estimation_data.graphe)
                      );
                    }
                    if (estimation_data.annonces) {
                      store.dispatch(
                        EstimationActions.setAnnonces(
                          estimation_data.annonces.result
                        )
                      );
                    }
                    if (estimation_data.ventes) {
                      store.dispatch(
                        EstimationActions.setVentes(
                          estimation_data.ventes.result
                        )
                      );
                    }
                    if (estimation_data.agences) {
                      store.dispatch(
                        EstimationActions.setAgences(
                          estimation_data.agences.results
                        )
                      );
                    }

                    // try {
                    //   await getGraphes(
                    //     estimation_data.geocoding.lat,
                    //     estimation_data.geocoding.lng,
                    //     estimation_data.results.estimation.vente,
                    //     estimation_data.type,
                    //     store.dispatch
                    //   );
                    // } catch (e) {}
                    // await getAgences(
                    //   estimation_data.geocoding.commune,
                    //   estimation_data.type,
                    //   store.dispatch
                    // );
                    // await getVentes(
                    //   estimation_data.geocoding.commune,
                    //   estimation_data.type,
                    //   store.dispatch
                    // );
                    // await getAnnonces(
                    //   estimation_data.geocoding.commune,
                    //   estimation_data.type,
                    //   store.dispatch
                    // );

                    store.dispatch(
                      EstimationActions.setEstimationId(
                        ctx.query.token || params.token
                      )
                    );
                    store.dispatch(
                      EstimationActions.setResultViewType("ESTIMATION")
                    );
                    if (activeStep == 10 || activeStep == 11) {
                      store.dispatch(
                        EstimationActions.setInitialState(estimation_data)
                      );
                      store.dispatch(
                        EstimationActions.setActiveStep(activeStep)
                      );
                      resolve({});
                    } else {
                      resolve({
                        redirect: {
                          destination: `/user/estimation?token=${
                            ctx.query.token || params.token
                          }`,
                          permanent: false,
                        },
                      });
                    }
                  })
                  .catch((err) => {
                    if (err.expired) {
                      if (activeStep !== 8 && activeStep !== 9) {
                        resolve({
                          redirect: {
                            destination: `/estimation/${
                              ctx.query.bien
                            }/signin?token=${ctx.query.token || params.token}`,
                            permanent: false,
                          },
                        });
                      } else {
                        store.dispatch(EstimationActions.setActiveStep(8));
                        resolve({});
                      }
                    } else {
                      resolve({
                        redirect: {
                          destination: `/estimation/map`,
                          permanent: false,
                        },
                      });
                    }
                  });
              }

              // DEAL WITH SHARE ID
              else if (ctx.query.shareId || params.shareId) {
                store.dispatch(
                  EstimationActions.setShareId(
                    ctx.query.shareId || params.shareId
                  )
                );
                api_call_v2(
                  ctx,
                  "post",
                  "estimation/shared",
                  { estimationId: ctx.query.shareId || params.shareId },
                  "cloud_functions",
                  true
                )
                  .then(async (estimation) => {
                    store.dispatch(
                      EstimationActions.setShareId(
                        ctx.query.shareId || params.shareId
                      )
                    );
                    let estimation_data = match(estimation.data);
                    if (estimation_data.graphe) {
                      store.dispatch(EstimationActions.setGraphes(res.data));
                    }
                    if (estimation_data.annonces) {
                      store.dispatch(
                        EstimationActions.setAnnonces(
                          estimation_data.annonces.result
                        )
                      );
                    }
                    if (estimation_data.ventes) {
                      store.dispatch(
                        EstimationActions.setVentes(
                          estimation_data.ventes.result
                        )
                      );
                    }
                    if (estimation_data.agences) {
                      store.dispatch(
                        EstimationActions.setAgences(
                          estimation_data.agences.results
                        )
                      );
                    }

                    store.dispatch(
                      EstimationActions.setResultViewType("SHARED")
                    );
                    if (activeStep == 10 || activeStep == 11) {
                      store.dispatch(
                        EstimationActions.setInitialState(estimation_data)
                      );
                      store.dispatch(
                        EstimationActions.setActiveStep(activeStep)
                      );
                      resolve({});
                    } else {
                      resolve({
                        redirect: {
                          destination: `/estimation/${
                            ctx.query.bien
                          }/resultat?shareId=${
                            ctx.query.shareId || params.shareId
                          }`,
                          permanent: false,
                        },
                      });
                    }
                  })
                  .catch((err) => {
                    if (err.expired) {
                      if (activeStep !== 8 && activeStep !== 9) {
                        resolve({
                          redirect: {
                            destination: `/estimation/${
                              ctx.query.bien
                            }/signin?shareId=${
                              ctx.query.shareId || params.shareId
                            }`,
                            permanent: false,
                          },
                        });
                      } else {
                        store.dispatch(EstimationActions.setActiveStep(8));
                        resolve({});
                      }
                    } else {
                      resolve({
                        redirect: {
                          destination: `/estimation/map`,
                          permanent: false,
                        },
                      });
                    }
                  });
              } else if (ctx.query.updateid || params.updateid) {
                api_call_v2(
                  ctx,
                  "post",
                  "estimation/user/estimation",
                  {
                    estimationId: ctx.query.updateid || params.updateid,
                    force_send_email: true,
                  },
                  "cloud_functions",
                  true
                )
                  .then(async (estimation) => {
                    let estimation_data = match(estimation.data);
                    store.dispatch(
                      EstimationActions.setEstimationId(
                        ctx.query.updateid || params.updateid
                      )
                    );
                    store.dispatch(
                      EstimationActions.setResultViewType("ESTIMATION")
                    );
                    if (activeStep == 10 || activeStep == 11) {
                      store.dispatch(
                        EstimationActions.setInitialState(estimation_data)
                      );
                      store.dispatch(
                        EstimationActions.setActiveStep(activeStep)
                      );
                      resolve({});
                    } else {
                      resolve({
                        redirect: {
                          destination: `/user/${
                            ctx.query.bien
                          }/estimation?token=${
                            ctx.query.updateid || params.updateid
                          }`,
                          permanent: false,
                        },
                      });
                    }
                  })
                  .catch((err) => {
                    if (err.expired) {
                      if (activeStep !== 8 && activeStep !== 9) {
                        resolve({
                          redirect: {
                            destination: `/estimation/${
                              ctx.query.bien
                            }/signin?token=${ctx.query.token || params.token}`,
                            permanent: false,
                          },
                        });
                      } else {
                        store.dispatch(EstimationActions.setActiveStep(8));
                        resolve({});
                      }
                    } else {
                      resolve({
                        redirect: {
                          destination: `/estimation/map`,
                          permanent: false,
                        },
                      });
                    }
                  });
              } else {
                if (activeStep == 1 || activeStep == 0) {
                  store.dispatch(EstimationActions.setActiveStep(activeStep));
                  resolve({});
                } else {
                  resolve({
                    redirect: {
                      destination: `/estimation/map`,
                      permanent: false,
                    },
                  });
                }
              }
            }
            store.dispatch(setAuthenticated({}));
            store.dispatch(updateUser({ data: user }));
            store.dispatch(signInR({ data: user }));
            store.dispatch(setUID({ data: user._id }));
            store.dispatch(setEmail({ data: user.email }));
            store.dispatch(setUser({ data: user }));

            if (!user.phone) {
              store.dispatch(EstimationActions.setInCompleteSignup(true));
            }
          })
          .catch((e) => {
            store.dispatch(setAuthenticated(false));
            store.dispatch(setUser(null));

            if (activeStep !== 1 && activeStep !== 0) {
              resolve({
                redirect: {
                  destination: `/estimation/map`,
                  permanent: false,
                },
              });
            } else {
              store.dispatch(EstimationActions.setActiveStep(activeStep));
              resolve({});
            }
          });
        // DEAL WITH TOKEN ID
      }
      // CASE USER NOT CONNECTED
      else {
        if (ctx.query.shareId || params.shareId) {
          store.dispatch(
            EstimationActions.setShareId(ctx.query.shareId || params.shareId)
          );
          if (activeStep !== 8 && activeStep !== 9) {
            resolve({
              redirect: {
                destination: `/estimation/${ctx.query.bien}/signin?shareId=${
                  ctx.query.shareId || params.shareId
                }`,
                permanent: false,
              },
            });
          } else {
            store.dispatch(EstimationActions.setSelectedType(ctx.query.type));
            store.dispatch(EstimationActions.setActiveStep(8));
            resolve({});
          }
        } else if (ctx.query.token || params.token) {
          store.dispatch(
            EstimationActions.setEstimationId(ctx.query.token || params.token)
          );
          if (activeStep !== 8 && activeStep !== 9) {
            resolve({
              redirect: {
                destination: `/estimation/${ctx.query.bien}/signin?token=${
                  ctx.query.token || params.token
                }`,
                permanent: false,
              },
            });
          } else {
            store.dispatch(EstimationActions.setActiveStep(8));
            resolve({});
          }
        } else if (ctx.query.updateid || params.updateid) {
          store.dispatch(
            EstimationActions.setUpdateId(ctx.query.updateid || params.updateid)
          );
          if (activeStep !== 8 && activeStep !== 9) {
            resolve({
              redirect: {
                destination: `/estimation/${ctx.query.bien}/signin?updateid=${
                  ctx.query.updateid || params.updateid
                }`,
                permanent: false,
              },
            });
          } else {
            store.dispatch(EstimationActions.setActiveStep(8));
            resolve({});
          }
        } else {
          if (activeStep !== 1 && activeStep !== 0) {
            resolve({
              redirect: {
                destination: `/estimation/map`,
                permanent: false,
              },
            });
          } else {
            store.dispatch(EstimationActions.setActiveStep(activeStep));
            resolve({});
          }
        }
      }
    } catch (e) {
      resolve({});
    }
  });
};
